import type { Video } from 'expo-av';
import type { RefObject } from 'react';

import { IS_WEB } from '@utils';

interface ISelectPlayIconParams {
  isPlaying: boolean;
  isFinished: boolean;
}

export function selectPlayIcon({
  isPlaying,
  isFinished,
}: ISelectPlayIconParams) {
  if (isFinished) {
    return 'refresh-1';
  }

  return isPlaying ? 'pause-bold' : 'play1-bold';
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function getHTMLVideoElementFromRef(
  videoRef: RefObject<Video>,
) {
  if (
    IS_WEB &&
    videoRef.current &&
    videoRef.current._nativeRef.current
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const video = videoRef.current._nativeRef.current._video;

    return video as HTMLVideoElement | undefined;
  }

  return;
}
